'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeRangeSliderIcon = function TraceTypeRangeSliderIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M5.087 16.308L9.516 18.5l5.152-3.607 6.206 2.569 9.384-4.962 10.046 12.725', strokeMiterlimit: '10', strokeWidth: '2.348' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M5 33h15v6H5zm26 0h10v6H31z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M20 33h11v6H20z' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#25fdfc', d: 'M5 23l5 3 4-4 9 3 18-12', strokeMiterlimit: '10', strokeWidth: '2.348' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M23 42h-3V30h3m5 12h3V30h-3', strokeMiterlimit: '10', strokeWidth: '2.348' })
    );
};

exports.default = TraceTypeRangeSliderIcon;